export const iconFontAwesomeHumanitarianSchoolLock = (
	<i className="fa-solid fa-school-lock"></i>
);
